export class VersionCompareUtil {
  static isLower(current: string, minimum: string): boolean {
    const currentSegments = VersionCompareUtil.parse(current);
    const minimumSegments = VersionCompareUtil.parse(minimum);
    if (!currentSegments || !minimumSegments) return false;

    for (let i = 0; i < 3; i++) {
      if (currentSegments[i] < minimumSegments[i]) return true;
      if (currentSegments[i] > minimumSegments[i]) return false;
    }
    return false;
  }

  private static parse(version: string): [number, number, number] | null {
    const parts = version.split('.');
    if (parts.length > 3) return null;

    const segments = [0, 1, 2].map((i) => (i < parts.length ? Number(parts[i]) : 0));
    if (segments.some((segment) => !Number.isFinite(segment))) return null;

    return segments as [number, number, number];
  }
}
